import { StartTimerFromPreviousEntryModalComponent } from "./../start-timer-from-previous-entry-modal/start-timer-from-previous-entry-modal.component";
import { JobsService } from "../../jobs.service";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { HotToastService } from "@ngneat/hot-toast";
import { Subject } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Component, Input, OnInit } from "@angular/core";
import { JobTimeTrackingService } from "./job-time-tracking.service";
import { PreviousTimeTracked } from "../models/models";

@Component({
  selector: "app-job-time-tracking-modal",
  templateUrl: "./job-time-tracking-modal.component.html",
  styleUrls: ["./job-time-tracking-modal.component.scss"],
  imports: [FormsModule, ReactiveFormsModule],
})
export class JobTimeTrackingModalComponent implements OnInit {
  @Input() clientCompany;
  @Input() userId: number;
  @Input() job;
  public onClose: Subject<boolean>;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    public timeTrackingService: JobTimeTrackingService,
    public bsModalRef: BsModalRef,
    private toastrService: HotToastService,
    private dashboardService: DashboardService,
    private jobsService: JobsService,
    private modalService: BsModalService,
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
    this.form = this.formBuilder.group({
      notes: [null],
      is_billable: [false],
      type: ["client_work"],
      job_id: [this.job.id],
      new_entry: [true],
      company_id: [this.clientCompany.id],
    });
  }

  cancel() {
    this.bsModalRef.hide();
  }

  async confirm() {
    this.bsModalRef.hide();
    this.startTracking();
  }

  async startTracking() {
    this.timeTrackingService
      .startTimeTracking(this.form.value, this.job.uuid)
      .then(
        (res) => {
          this.timeTrackingService.isTracking.next(true);
          this.bsModalRef.hide();
          this.dashboardService.startTimeTracking.next(true);
          this.toastrService.success(
            `Time tracking started for job ${this.job.name} `,
          );
        },
        (err) => {
          this.toastrService.error(err.error.message);
        },
      );
  }
}
